"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.collection = void 0;
const axios_class_1 = require("./axios.class");
class Collection {
    forSale(marketplaceId, nftCollectionId) {
        return axios_class_1.axios.get(`/v1/marketplace/${marketplaceId}/nftCollections/forSale?nftCollectionId=${nftCollectionId}`);
    }
    async getUserCollection({ collectionId }) {
        // signal is use by the front to cancel a pending request
        const { data } = await axios_class_1.axios.get(`/v1/products/collection/${collectionId}`);
        return data;
    }
    async getAllByClientId(clientId) {
        const { data } = await axios_class_1.axios.get(`/nft-collections/${clientId}`);
        return data;
    }
}
exports.collection = new Collection();
